module.exports = __webpack_public_path__ + "img/jg5.4c1f61e6.png";